<template>
	<div class="content">
		<audio
			v-if="activeGame != ''"
			class="background-music"
			:src="require('@/assets/music/' + activeGame + '.mp3')"
		></audio>
		<div class="sound-control" @click="toggleSound()">
			<img
				v-if="soundStatus"
				src="@/assets/img/pixel/sound-on.png"
				alt=""
			/>
			<img v-else src="@/assets/img/pixel/sound-off.png" alt="" />
		</div>
		<div class="overlay">
			<div class="games">
				<button
					type="button"
					class="nes-btn is-success"
					@click="setActiveGame('hill')"
				>
					Collines mystères
				</button>
				<button
					type="button"
					class="nes-btn is-primary"
					@click="setActiveGame('mountains')"
				>
					Montagnes sacrées
				</button>
				<button
					type="button"
					class="nes-btn is-warning"
					@click="setActiveGame('sunset')"
				>
					Horizons perdus
				</button>
			</div>
			<div
				class="nes-pointer"
				id="start-message"
				@click="$emit('openGame')"
			></div>
		</div>
		<transition-group name="fade">
			<Hill v-if="activeGame === 'hill'" />
			<Mountains v-if="activeGame === 'mountains'" />
			<Sunset v-if="activeGame === 'sunset'" />
		</transition-group>
	</div>
</template>

<script>
import Hill from "./partials/Hill.vue";
import Mountains from "./partials/Mountains.vue";
import Sunset from "./partials/Sunset.vue";
export default {
	data() {
		return {
			activeGame: "hill",
			soundStatus: false,
		};
	},
	name: "Start",
	components: {
		Hill,
		Mountains,
		Sunset,
	},
	mounted() {
		this.printLetterByLetter("start-message", 50);
	},
	methods: {
		setActiveGame: function (game) {
			this.activeGame = game;
			setTimeout(() => {
				if(this.soundStatus) {
					let player = document.querySelector(".background-music");
					player.play();
				}
			}, 300);
		},
		printLetterByLetter: function (destination, speed) {
			let i = 0;
			const message = "Cliquez ici ou appuyer sur Entrée pour commencer";
			let interval = setInterval(function () {
				document.getElementById(destination).innerHTML +=
					message.charAt(i);
				i++;
				if (i > message.length) {
					clearInterval(interval);
				}
			}, speed);
		},
		toggleSound: function () {
			let player = document.querySelector(".background-music");
			console.log(player.paused);
			if (player.paused) {
				player.volume = 0.2;
				player.play();
			} else {
				player.pause();
			}
			this.soundStatus = !this.soundStatus;
		},
	},
};
</script>

<style lang="scss">
.content {
	overflow: hidden;
}
.overlay {
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	top: 0;
	left: 0;
	z-index: 99;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #ffffff;
	.games {
		margin: 1rem 0;
		button {
			display: block;
			font-size: 1.1rem;
			margin: 1rem 0;
			width: 100%;
		}
	}
	.nes-pointer {
		text-align: center;
		padding: 0 60px;
		animation: blinking 2s linear infinite;
	}
}
.sound-control {
	position: absolute;
	bottom: 0;
	right: 10px;
	z-index: 1000;
	img {
		width: 40px;
	}
}
@keyframes blinking {
	0% {
		opacity: 0;
	}
	33% {
		opacity: 1;
	}
	66% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
